/* eslint-disable no-console */

const LOG_LEVEL = ['NONE', 'ERROR', 'WARN', 'INFO', 'DEBUG'];
const DEFAULT_LEVEL = 'NONE';

function shouldLog(level: string): boolean {
	const logLevel = process.env.LOG_LEVEL?.toUpperCase() || DEFAULT_LEVEL;
	return LOG_LEVEL.indexOf(logLevel) >= LOG_LEVEL.indexOf(level);
}

// this avoids passing 'undefined' argument to console methods
function optional<T>(data?: T): T[] {
	return data !== undefined ? [data] : [];
}

export const Logger = {
	debug: (message: string, data?: unknown): void => {
		if (shouldLog('DEBUG')) {
			console.debug(message, ...optional(data));
		}
	},

	info: (message: string, data?: unknown): void => {
		if (shouldLog('INFO')) {
			console.info(message, ...optional(data));
		}
	},

	warn: (message: string, data?: unknown): void => {
		if (shouldLog('WARN')) {
			console.warn(message, ...optional(data));
		}
	},
};
